import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class BatchService {
  batchData: any = {};
  url: string = `${environment.apiUrl}v1/Batch`;

  constructor(private http: HttpClient) {}

  private header() {
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return headers;
  }

  getAllBatch(
    pageNumber?: number,
    pageSize?: number,
    status?: string,
    userDetails?: string,
    storeId?: number | null,
  ) {
    const params: any = {};
    if (pageNumber !== undefined) params.PageNumber = pageNumber.toString();
    if (pageSize !== undefined) params.PageSize = pageSize.toString();
    if (status) params.Status = status;
    if (userDetails) params.UserDetails = userDetails;

    if (storeId !== null && storeId !== undefined) {
      params.StoreId = storeId.toString();
    }
    return this.http.get(`${this.url}/List`, {
      headers: this.header(),
      params: params,
    });
  }

  getBatchById(batchId: string) {
    return this.http.get(`${this.url}/${batchId}`, {
      headers: this.header(),
    });
  }
  updateBatchStatus(batchId: string, status: string) {
    return this.http.put(
      `${this.url}/${batchId}/${status}`,
      {},
      {
        headers: this.header(),
      },
    );
  }
  updateBatch(batch: any) {
    return this.http.put(
      `${this.url}`,
      { batch },
      {
        headers: this.header(),
      },
    );
  }
  updateAvailability(updatePayload: any) {
    return this.http.put<any>(`${this.url}`, updatePayload, {
      headers: this.header(),
    });
  }
  getToken(): string | null {
    const name = 'authToken=';
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(name)) {
        const token = cookie.substring(name.length);
        return token;
      }
    }
    return null;
  }
}
